// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"TabResources-module-tab-content-2OCJZ","tabContent":"TabResources-module-tab-content-2OCJZ","title":"TabResources-module-title-2V4RV","items-group":"TabResources-module-items-group-2ESZN","itemsGroup":"TabResources-module-items-group-2ESZN"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/TabResources/TabResources.module.scss
// module id = 1269
// module chunks = 0